export class Newsletter
{

	constructor ()
	{

		this.umURL       = "https://account.bellmedia.ca/api/newsletter/v1.1/register?recaptchaToken="
		this.googleToken = "6Lfv5XAUAAAAAAXwhe8t2ssyPuoiMuFE2XyJzpEF"


		this.btnSubTrigger = document.querySelector( '.btn-newlsetter-trigger' );

		this.modalContainer = document.querySelector( '.infolettre-container' );

		this.infolettreModal = this.modalContainer.querySelector( '.infolettre-modal' );
		this.form            = this.modalContainer.querySelector( '#sign-up-form' );
		this.btnCloseModal   = this.modalContainer.querySelector( '.btn-close-newsletter-form' );
		this.selects         = this.modalContainer.querySelectorAll( 'select' );

		if ( this.selects.length > 0 )
		{
			this.setupSelects();
		}

		this.fieldEmail            = this.form.querySelector( '#newsletter-email' );
		this.fieldEmailVerify      = this.form.querySelector( '#verifyEmail' );
		this.fieldProvince         = this.form.querySelector( '#select-province' );
		this.fieldAgreedNewsletter = this.form.querySelector( '#agreedNewsletter' );

		this.fieldErrorMismatchedEmails = this.form.querySelector( '.verify-email .invalid-feedback' );
		this.fieldErrorNoProvince       = this.form.querySelector( '.form-group.province .invalid-feedback' );
		this.fieldErrorNotAccepted      = this.form.querySelector( '.form-group-checkbox.accepted .invalid-feedback' );

		this.fieldSubmit = this.form.querySelector( '#submit-form' );


		this.successModal    = this.modalContainer.querySelector( '.infolettre-modal-success' );
		this.successBtnClose = this.successModal.querySelector( '.btn-close-success' );

		this.allFields = [
			this.fieldEmail,
			this.fieldEmailVerify,
			this.fieldProvince,
			this.fieldAgreedNewsletter,
		];


		this.changeNewsletterUrlForDev();

		this.resetForm();
		this.resetErrors();

		this.bindEvents();

	}


	bindEvents ()
	{
		this.btnSubTrigger.addEventListener( 'click', this.openModal.bind( this ) );

		this.modalContainer.addEventListener( 'click', this.closeModal.bind( this ) );
		this.btnCloseModal.addEventListener( 'click', this.closeModal.bind( this ) );


		// bind all these events for the input fields
		const fieldEvents = [ 'change', 'blur' /*'keyup', 'input' */ ];
		this.allFields.forEach( f =>
		{

			fieldEvents.forEach( ev =>
			{
				f.addEventListener( ev, this.validation.bind( this ) );
			} );

		} );

		this.form.addEventListener( 'submit', this.submitNewsletterForm.bind( this ) );


		this.successBtnClose.addEventListener( 'click', this.closeSuccessModal.bind( this ) );
	}

	setupSelects ()
	{
		Array.from( this.selects ).forEach( s =>
		{
			const $select = $( s );

			$select.select2( {
				minimumResultsForSearch : Infinity,
				dropdownParent          : $select.parent(),
				width                   : '100%',
			} );
		} )
	}

	openModal ( event )
	{
		this.resetErrors();
		this.resetForm();

		this.modalContainer.classList.add( 'open' );
		this.infolettreModal.classList.add( 'open' );

		setTimeout( () =>
		{
			this.infolettreModal.querySelector( '.inner' ).scrollTop = 0;
		}, 100 );
	}


	closeModal ( event, forceClose )
	{

		// we only care about closing if they clicked the backdrop
		// or the close button
		if (
			!forceClose &&
			!event.target.classList.contains( 'infolettre-container' )
			&& !event.target.classList.contains( 'btn-close-newsletter-form' )
		)
		{
			console.log( 'Not the closers we want', event )
			return true;
		}

		this.infolettreModal.classList.remove( 'open' );
		this.modalContainer.classList.remove( 'open' );
		this.resetForm();
	}

	openSuccessModal ( event )
	{

		this.successModal.classList.add( 'open' );
		this.modalContainer.classList.add( 'open' );
	}


	closeSuccessModal ( event, forceClose )
	{

		// we only care about closing if they clicked the backdrop
		// or the close button
		if (
			!forceClose &&
			!event.target.classList.contains( 'infolettre-container' )
			&& !event.target.classList.contains( 'btn-close-success' )
		)
		{
			console.log( 'Not the closers we want', event )
			return true;
		}

		this.successModal.classList.remove( 'open' );
		this.modalContainer.classList.remove( 'open' );
	}

	changeNewsletterUrlForDev ()
	{
		if (
			window.location.host.indexOf( "localhost" ) !== -1
			|| window.location.host.indexOf( "staging" ) !== -1
			|| window.location.host.indexOf( "dev" ) !== -1 )
		{
			this.umURL       = "https://sandbox.account.bellmedia.ca/api/newsletter/v1.1/register?recaptchaToken=";
			this.googleToken = "6LevzpMUAAAAAG1atlg3Vk0R_oFvKdV-lSk7zLwc";

			console.log( 'Changing the Bell and Google values for dev.' );
		}
	}


	resetForm ()
	{

		this.fieldEmail.value            = "";
		this.fieldEmailVerify.value      = "";
		this.fieldProvince.selectedIndex = null;
		this.fieldAgreedNewsletter.value = "";

		this.fieldSubmit.disabled = true;

		this.infolettreModal.querySelector( '.inner' ).scrollTop = 0;

		this.resetErrors();
	}


	resetErrors ()
	{
		this.fieldEmail.classList.remove( 'is-invalid' );
		this.fieldEmailVerify.classList.remove( 'is-invalid' );
		this.fieldProvince.classList.remove( 'is-invalid' );
		this.fieldAgreedNewsletter.classList.remove( 'is-invalid' );

		this.fieldErrorMismatchedEmails.style.display              = "none";
		this.fieldErrorMismatchedEmails.attributes[ 'ara-hidden' ] = true;

		this.fieldErrorNoProvince.style.display              = "none";
		this.fieldErrorNoProvince.attributes[ 'ara-hidden' ] = true;

		this.fieldErrorNotAccepted.style.display              = "none";
		this.fieldErrorNotAccepted.attributes[ 'ara-hidden' ] = true;
	}

	validation ()
	{

		let isValid = true;

		this.resetErrors();

		const email             = this.fieldEmail.value.trim();
		const emailVerification = this.fieldEmailVerify.value.trim();
		const province          = this.fieldProvince.value;
		const accepted          = this.fieldAgreedNewsletter.checked;

		console.log(
			'email', email,
			'emailVerification', emailVerification,
			'province', province,
			'accepted', accepted,
		)

		if ( email.length < 1 )
		{
			isValid = false;
		}

		if ( emailVerification.length < 1 )
		{
			isValid = false;
		}


		if ( emailVerification.length > 0 && email !== emailVerification )
		{
			isValid = false;

			this.fieldErrorMismatchedEmails.style.display              = "block";
			this.fieldErrorMismatchedEmails.attributes[ 'ara-hidden' ] = false;
		}


		if ( province.length < 0 )
		{
			isValid = false;

			this.fieldErrorNoProvince.style.display              = "block";
			this.fieldErrorNoProvince.attributes[ 'ara-hidden' ] = false;
		}


		if ( !accepted )
		{
			isValid = false;

			this.fieldErrorNotAccepted.style.display              = "block";
			this.fieldErrorNotAccepted.attributes[ 'ara-hidden' ] = false;
		}


		// disabled the submit if not valid
		this.fieldSubmit.disabled = !isValid;

		console.log( 'Validation.... validated = ' + isValid, 'province=' + province );


		return isValid;
	}


	getExternalId ( email, token )
	{
		var payload = {
			"email"      : email,
			"brandName"  : "crave",
			"vendorName" : "Braze",
		}
		return $.ajax( {
			type        : "POST",
			url         : this.umURL + token,
			data        : JSON.stringify( payload ),
			contentType : "application/json; charset=utf-8",
			dataType    : "json",
			success     : function ( data )
			{
				return data;
			},
			error       : function ( error )
			{
				console.error( error );
			},
		} );
	}

	submitNewsletterForm ( event )
	{

		event.preventDefault();

		const valid = this.validation();

		if ( !valid )
		{
			return false;
		}


		const email = this.fieldEmail.value.trim();
		// const emailVerification = this.fieldEmailVerify.value.trim();
		const province          = this.fieldProvince.value;
		// const accepted          = this.fieldAgreedNewsletter.checked;


		grecaptcha.ready( () =>
		{

			try
			{
				grecaptcha.execute( this.googleToken, { action : 'submit' } ) // get google token

					.then( ( token ) =>
					{

						this.getExternalId( email, token )
							.then( ( response ) =>
							{

								if ( response && response.accountId )
								{

									const accountId = response.accountId;

									appboy.changeUser( accountId );
									appboy.getUser().setEmail( response.email );
									appboy.getUser().setEmailNotificationSubscriptionType( 'opted_in' );
									appboy.getUser().setLanguage( "fr" );
									appboy.getUser().setCustomUserAttribute( "newsletter_se_subscribed", true );
									appboy.getUser().setCustomUserAttribute( "newsletter_se_optin_date", moment().format() );
									appboy.getUser().setCustomUserAttribute( "newsletter_se_province", province );
									appboy.getUser().setCustomUserAttribute( "province", province );
									appboy.requestImmediateDataFlush( ( response ) =>
									{
										if ( response )
										{

											this.closeModal( null, true );
											this.openSuccessModal();

										} else
										{
											console.log( "Error while sending form" );
										}
									} );
								}
							} );
					} )
			}

			catch (e)
			{
				console.error( 'Problem getting the reCAPTCHA' + "\n", e );

			}
		} );
	}
}